<script setup lang="ts">
import { usePermissionsModal } from '@/composables/usePermissionsModal';

const { isVisible, hide, error } = usePermissionsModal()

</script>

<template>
  <VDialog 
    v-model="isVisible" 
    :max-width="$vuetify.display.smAndDown ? '100%' : '500'"
    :fullscreen="$vuetify.display.xs"
    @click.self="hide"
  >
    <VCard>
      <VCardTitle class="text-h6 d-flex justify-space-between align-center pa-6">
        <span>{{ error.title }}</span>
        <VBtn icon="tabler-x" variant="text" @click="hide" />
      </VCardTitle>
      <VDivider />
      <VCardText class="pa-6">
        <p v-if="error.code === 401">Сессия завершена.</p>
        <template v-else-if="error.code === 403">
          <p v-if="error.message">У вас нет необходимых разрешений для выполнения действия {{ error.message }}.</p>
          <p v-else>У вас нет необходимых разрешений для выполнения действия.</p>
          <p>Обратитесь к администратору для получения доступа.</p>
        </template>
        <p v-else>Произошла непредвиданная ошибка. Обратитесь к администратору.</p>
      </VCardText>
      <VCardActions class="pa-6">
        <VSpacer />
        <VBtn color="primary" variant="flat" @click="hide">Понятно</VBtn>
      </VCardActions>
    </VCard>
  </VDialog>
</template>

<style scoped>
</style>
